import { LunchLitelyService, LunchLitelyServiceModule } from '@b2b/common/services/lunchLitely/lunchLitely.service';
import { ContentHeaderService, ContentHeaderServiceModule } from '@b2b/common/services/contentHeader';
import { ACMEResponse, TODO } from '@b2b/types/core';
import uiRouter, { StateParams } from '@uirouter/angularjs';
import angular, { IHttpService, IScope } from 'angular';
import { AppStoreComponentModule, AppStoreEnv } from '../components/app-store';

const DEFAULT_APP_STORE_ENV: AppStoreEnv = 'production';

export interface AppStoreTokenResponse {
  token: string;
}

AppStoreController.$inject = ['$scope', '$http', '$stateParams', 'ContentHeaderService', 'LunchLitelyService'];

export function AppStoreController(
  $scope: IScope & { appStore: TODO },
  $http: IHttpService,
  $stateParams: StateParams,
  contentHeaderService: ContentHeaderService,
  lunchLitelyService: LunchLitelyService,
) {
  const ctrl = {
    state: 'loading' as 'loading' | 'error' | 'ready',
    apiKey: '' as string,
    env: DEFAULT_APP_STORE_ENV as AppStoreEnv,
    appId: ($stateParams.appId as string) || '',

    init() {
      contentHeaderService.update({ title: 'Integration & Apps' });

      Promise.all([ctrl.fetchToken(), ctrl.resolveEnv()])
        .then(([apiKey]) => {
          ctrl.apiKey = apiKey;
          ctrl.state = 'ready';
        })
        .catch(() => {
          ctrl.state = 'error';
        });
    },

    resolveEnv() {
      return lunchLitelyService
        .getVariation<AppStoreEnv>('app_store_env', DEFAULT_APP_STORE_ENV)
        .then((env) => {
          // A disabled multivariate flag with no default_variation configured
          // evaluates to "" rather than the getVariation default, so guard it here too.
          ctrl.env = env || DEFAULT_APP_STORE_ENV;
        })
        .catch(() => {
          ctrl.env = DEFAULT_APP_STORE_ENV;
        });
    },

    handleAppStoreError(error: Error) {
      console.error('AppStore error:', error);
      ctrl.state = 'error';
    },

    fetchToken() {
      return $http.post<ACMEResponse<AppStoreTokenResponse>>('/v2/api/app-store/token', {}).then((response) => {
        if (!response.data.success || !response.data.payload?.token) {
          throw new Error('Failed to fetch app store token');
        }
        return response.data.payload.token;
      });
    },
  };

  $scope.appStore = ctrl;
  ctrl.init();
}

export const AppStoreControllerModule = angular
  .module('acme.view.application.app-store.controllers', [
    uiRouter,
    'ui.bootstrap',
    ContentHeaderServiceModule,
    AppStoreComponentModule,
    LunchLitelyServiceModule,
  ])
  .controller('AppStoreController', AppStoreController).name;
